exports.formatMoney = (val) => {
	if (val) {
		val = val.toString().replace(/\$|\,/g, '');
		if (isNaN(val)) {
			val = "0";
		}
		let sign = (val == (val = Math.abs(val)));
		val = Math.floor(val * 100 + 0.50000000001);
		let cents = val % 100;
		val = Math.floor(val / 100).toString();
		if (cents < 10) {
			cents = "0" + cents
		}
		for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
			val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3));
		}
		return (((sign) ? '' : '-') + val + '.' + cents);
	}
	return '0.00';
};

exports.NumFormat = (value) => { // 数字格式化
	if (!value||value == undefined||value.length<=0) {
		return '0'
	}
	return value;
};

exports.NumTwoPoint = (value) => { // 全局过滤保留小数点后两位
	if (value == undefined || value == 0) {
		return '0'
	}
	return Number(value).toFixed(2);
};

exports.NumPoint = (value,lenght) => { // 全局过滤保留小数点后两位
	if (value == undefined || value == 0) {
		return Number(0).toFixed(lenght)
	}
	return Number(value).toFixed(lenght);
};

exports.NumRatio = (value) => { // 全局过滤保留小数点后两位
	if (value == undefined || value == 0) {
		return '0.00%'
	}
	return Number(value).toFixed(2)+'%';
};

//时间格式化
exports.DateFormate = (value, fmt) => {
	var date;
	if(!value)
	{
		return "";
	}
	if(typeof value === 'string'){
		date = new Date(value.replace(/-/g,'/').replace(/T|Z/g,' ').trim());
	}else if(typeof value === 'object'){
		date = new Date(value) ;
	}

	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds()
	}
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + ''
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : (('00' + str).substr(str.length)))
		}
	}
	return fmt
};

//时间格式化
exports.DateStrFormate = (value, fmt) => {
	if(!value)
		return "";
	let getDate = new Date(value);
	let o = {
		'M+': getDate.getMonth() + 1,
		'd+': getDate.getDate(),
		'h+': getDate.getHours(),
		'm+': getDate.getMinutes(),
		's+': getDate.getSeconds(),
		'q+': Math.floor((getDate.getMonth() + 3) / 3),
		'S': getDate.getMilliseconds()
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
	}
	for (let k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
		}
	}
	return fmt;
};

exports.ValueBind = (value,DataArray,fromkey,resKey) => { // 获取绑定值
	if(DataArray&&DataArray.length>0)
	{
		for (let index = 0; index < DataArray.length; index++) {
			const item = DataArray[index];
			var iv=eval("item."+fromkey);
			if(iv==value)
			{
				return eval("item."+resKey);
			}
			
		}
	}
	return value;
};



// WEBPACK FOOTER //
// ./src/filter/index.js